import './styling.scss';
import * as template from './template.html';

import * as angular from 'angular';
import * as componentsModule from './components';
import { FlagshipService } from 'services/flagship';
import { CurrentUserService } from 'services/currentUser';
import { checkFeatureFlagAndRedirect } from 'utilities/featureFlags';

const module = angular.module('get-more-page', [componentsModule.module.name]);

interface GetMorePageController extends angular.IStrictController {
    policyIndex: RoutePolicyIndex;
    policyInfo: CustomerPolicyInfo;
}

module.component('getMorePage', {
    template: template,
    bindings: {
        policyIndex: '<',
        policyInfo: '<'
    },
    controller: function(
        this: GetMorePageController,
        flagshipService: FlagshipService,
        currentUserService: CurrentUserService,
        $stateParams: PolicyStateParams,
        $window: angular.IWindowService,
        $scope: angular.IScope
    ) {
        const checkFeatureFlag = () => {
            checkFeatureFlagAndRedirect('ReactGetMorePage', flagshipService, $window,  currentUserService, $stateParams.policyIndex);
        };

        this.$onInit = () => {
            if (flagshipService.getFeatureFlagStatus() === 'FeatureFlagStatus:Ready') {
                checkFeatureFlag();
            } else {
                $scope.$on('FeatureFlagStatus:Ready', () => {
                    checkFeatureFlag();
                });
            }
        };
    }
});

export { module };
